import { Menu, type MenuSelectGroupProps, Text } from "@overmap-ai/blocks"
import type { Form, Stored } from "@overmap-ai/common"
import { memo } from "react"

import { SelectItemTemplate } from "../MenuGroups/constants"

export type FormSelectGroupProps = MenuSelectGroupProps<Stored<Form>> & {
	forms: Stored<Form>[]
}

export const FormSelectGroup = memo<FormSelectGroupProps>((props) => {
	const { ref, forms, ...rest } = props

	return (
		<Menu.SelectGroup<Stored<Form>> ref={ref} {...rest}>
			{forms.map((form) => {
				return (
					<SelectItemTemplate<Stored<Form>> key={form.uuid} value={form}>
						<Text className="truncate">{form.name}</Text>
					</SelectItemTemplate>
				)
			})}
		</Menu.SelectGroup>
	)
})
FormSelectGroup.displayName = "FormSelectGroup"
